/**
 * `events` — venue/event info card (legacy from v1, kept so no data is lost
 * at migration; the gig header holds name/venue/city, this holds the extras).
 */
import { z } from "zod";
import { defineCollection, field } from "../define.ts";

export const events = defineCollection({
  key: "events",
  labelKey: "collections.events",
  icon: "building",
  sheetTab: "Event info",
  dedupFields: ["name"],
  sort: [{ field: "name" }],
  split: "gig",
  chatHint:
    "Venue/event details beyond the gig header: full address, website, capacity, venue notes. " +
    "Legacy v1 collection kept for lossless migration.",
  fields: {
    name: field({
      type: z.string().optional(),
      tier: "hot",
      pii: "promoter",
      labelKey: "events.name",
      sheet: { column: "Name" },
      description: "Event or venue name (the gig header's venue is canonical; this is the info card).",
    }),
    address: field({
      type: z.string().optional(),
      tier: "hot",
      pii: "promoter",
      labelKey: "events.address",
      sheet: { column: "Address" },
      description: "Full street address (feeds maps links).",
    }),
    city: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "promoter",
      labelKey: "events.city",
      sheet: { column: "City" },
      description: "City.",
    }),
    country: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "promoter",
      labelKey: "events.country",
      sheet: { column: "Country" },
      description: "Country (ISO code or name).",
    }),
    website: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "promoter",
      labelKey: "events.website",
      sheet: { column: "Website" },
      description: "Venue/event website.",
    }),
    capacity: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "promoter",
      labelKey: "events.capacity",
      sheet: { column: "Capacity" },
      description: "Venue capacity.",
    }),
    notes: field({
      type: z.string().optional(),
      tier: "detail",
      pii: "crew",
      labelKey: "events.notes",
      sheet: { column: "Notes" },
      description: "Access, parking, load-in quirks.",
    }),
  },
});
